export const ValidateCheckout = values => {
	const errors = {};

	if (values.first_ticket_timer < 1)
		errors.first_ticket_timer = "Minimum checkout time allowed is 1 min";
	else if (values.first_ticket_timer > 30)
		errors.first_ticket_timer = "Maximum checkout time allowed is 30 min";

	if (values.additional_ticket_timer < 1)
		errors.additional_ticket_timer = "Minimum checkout time allowed is 1 min";
	else if (values.additional_ticket_timer > 30)
		errors.additional_ticket_timer = "Maximum checkout time allowed is 30 min";
	return errors;
};

export default ValidateCheckout;

export const validateTicketUrl = values => {
	const errors = {
		utm_configuration: {}
	};
	if (!values.url_name || values.url_name.trim() === "") {
		errors.url_name = "Please provide URL Name";
	}
	if (values.url_name && values.url_name.length < 5) {
		errors.url_name =
			"The URL name is too short. Please ensure it has a minimum length of 5 characters to proceed.";
	}
	if (Object.keys(values.tickets_configuration).length === 0) {
		errors.tickets_configuration = "Please select at least one ticket";
	}
	if (Object.values(values.tickets_configuration).includes("")) {
		errors.tickets_configuration =
			"A minimum of one ticket is required. Please adjust your selection.";
	}
	if (values.utm_configuration.source && values.utm_configuration.source.trim() === "") {
		errors.utm_configuration["source"] = "Please provide valid UTM Source";
	}
	if (values.utm_configuration.medium && values.utm_configuration.medium.trim() === "") {
		errors.utm_configuration["medium"] = "Please provide valid UTM Medium";
	}
	if (values.utm_configuration.campaign && values.utm_configuration.campaign.trim() === "") {
		errors.utm_configuration["campaign"] = "Please provide valid UTM Campaign";
	}

	if (
		!errors.utm_configuration["source"] &&
		!errors.utm_configuration["medium"] &&
		!errors.utm_configuration["campaign"]
	) {
		delete errors["utm_configuration"];
	}
	return errors;
};

export const domainValidation = values => {
	const errors = {};

	if (values.restriction_type.length === 0)
		errors.restriction_type = "You need to select the type of domain restriction";

	if (values.domain_names.length == 0)
		errors.domain_names = "Please enter atleast one Domain Name";

	if (values.error_message == "") errors.error_message = "Please enter a error message";

	if (values.attached_tickets.length == 0) errors.attached_tickets = "Please select a ticket";

	return errors;
};

export const ValidateSequenceNumber = (values, forms) => {
	const errors = {};
	const multiLangRegex = /^[\p{L}\p{N}\p{M}\p{S}\p{P}\p{Z}]+$/u;


	if (values.sequence_name === "") errors.sequence_name = "Please provide Sequence Name";
	else if (!multiLangRegex.test(values?.sequence_name)) {
		errors.sequence_name =
			"The platform supports only English. Kindly provide your details in English.";
	} else if (values.sequence_name.length < 2)
		errors.sequence_name = "Sequence Name should be of minimum 2 characters length";

	if (values.starting_number === "") errors.starting_number = "Please provide Starting Number";

	if (values.increase_by === "") {
		errors.increase_by = "Please provide Increase By";
	} else if (values.increase_by == 0) {
		errors.increase_by = "Please provide Increase By greater than 0";
	}

	if (values.attached_tickets.length == 0) errors.attached_tickets = "Please attach tickets";

	const selectedForm = forms.find(
		form =>
			values.form_conditions.length > 0 && form.form_id === values.form_conditions[0].form_id
	);
	if (selectedForm) {
		const attachedTickets = selectedForm.attached_tickets;
		const unmatchedTickets = values.attached_tickets.filter(
			ticketId => !attachedTickets.includes(ticketId)
		);
		if (unmatchedTickets.length > 0) {
			errors.form_conditions =
				"The selected tickets do not match the forms selected. Please review and select the appropriate tickets to continue.";
		}
	}

	return errors;
};
export const ValidatePostRegistration = values => {
	const errors = {};

	if (values.reg_success_title === "")
		errors.reg_success_title = "Please add Post Registration Success Title";
	else if (values.reg_success_title.length > 500)
		errors.reg_success_title =
			"Please add Post Registration Success Title less than 500 character";

	if (values.reg_success_msg === "")
		errors.reg_success_msg = "Please add Post Registration Success Description";
	else if (values.reg_success_msg.length > 2000)
		errors.reg_success_msg =
			"Please add Post Registration Success Description less than 2000 character";

	if (values.approval_success_title === "")
		errors.approval_success_title = "Please add Post Approval Registration Title";
	else if (values.approval_success_title.length > 500)
		errors.approval_success_title =
			"Please add Post Approval Registration Title less than 500 character";

	if (values.approval_success_msg === "")
		errors.approval_success_msg = "Please add Post Approval Registration Description";
	else if (values.approval_success_msg.length > 2000)
		errors.approval_success_msg =
			"Please add Post Approval Registration Description less than 2000 character";

	if (values.waitlist_success_title === "")
		errors.waitlist_success_title = "Please add Post waitlist Registration Title";
	else if (values.waitlist_success_title.length > 500)
		errors.waitlist_success_title =
			"Please add Post waitlist Registration Title less than 500 character";

	if (values.waitlist_success_msg === "")
		errors.waitlist_success_msg = "Please add Post waitlist Registration Description";
	else if (values.waitlist_success_msg.length > 2000)
		errors.waitlist_success_msg =
			"Please add Post waitlist Registration Description less than 2000 character";

	return errors;
};
